import { render } from "./CategoryComponent.vue?vue&type=template&id=b2d11d1e"
import script from "./CategoryComponent.vue?vue&type=script&lang=js"
export * from "./CategoryComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/home/CategoryComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b2d11d1e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b2d11d1e', __exports__)) {
    api.reload('b2d11d1e', __exports__)
  }
  
  module.hot.accept("./CategoryComponent.vue?vue&type=template&id=b2d11d1e", () => {
    api.rerender('b2d11d1e', render)
  })

}


export default __exports__